import React from 'react';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const DateRangeFilter = ({ filters, onFilterChange, showDays = false, showMonths = false }) => {
  const handleDateChange = (field, value) => {
    onFilterChange({
      ...filters,
      [field]: value ? new Date(value).toISOString().split('T')[0] : ''
    });
  };

  const handleNumberChange = (field, value) => {
    onFilterChange({
      ...filters,
      [field]: parseInt(value) || 30
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <DatePicker
              label="Start Date"
              value={filters.start_date ? new Date(filters.start_date) : null}
              onChange={(date) => handleDateChange('start_date', date)}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DatePicker
              label="End Date"
              value={filters.end_date ? new Date(filters.end_date) : null}
              onChange={(date) => handleDateChange('end_date', date)}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </Grid>
          
          {showDays && (
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel>Analysis Period</InputLabel>
                <Select
                  value={filters.days || 30}
                  label="Analysis Period"
                  onChange={(e) => handleNumberChange('days', e.target.value)}
                >
                  <MenuItem value={7}>Last 7 Days</MenuItem>
                  <MenuItem value={30}>Last 30 Days</MenuItem>
                  <MenuItem value={90}>Last 90 Days</MenuItem>
                  <MenuItem value={180}>Last 6 Months</MenuItem>
                  <MenuItem value={365}>Last Year</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}

          {showMonths && (
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel>Months</InputLabel>
                <Select
                  value={filters.months || 12}
                  label="Months"
                  onChange={(e) => handleNumberChange('months', e.target.value)}
                >
                  <MenuItem value={3}>3 Months</MenuItem>
                  <MenuItem value={6}>6 Months</MenuItem>
                  <MenuItem value={12}>1 Year</MenuItem>
                  <MenuItem value={24}>2 Years</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
        </Grid>
      </Box>
    </LocalizationProvider>
  );
};

export default DateRangeFilter;